import React, { useEffect } from 'react';
import { Spin } from 'antd';
import { Header } from '../Header/Header';
import { Navigation } from '../Navigation/Navigation';
import { MainRoutes } from '../MainRoutes/MainRoutes';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../../../types/types';
import { useAppDispatch, useAppSelector } from '../../../../core/redux';
import { getUrlParams } from '../../../tables/helpers/helpers';
import { tablesSlice } from '../../../tables/TablesSlice';

import s from './MainPage.module.scss';
const { setDocumentTab } = tablesSlice.actions;

export const MainPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isLoading } = useAppSelector((state) => state.authorizationReducer);
  const { params } = getUrlParams(window.location.href);

  useEffect(() => {
    if (!params.code && !params.editableTableKey) {
      navigate(routes.tableAllProjects);
      dispatch(setDocumentTab('general'));
    } else {
      dispatch(setDocumentTab('CDA'));
    }
  }, [dispatch]);
  return (
    <div className={s.MainPage}>
      <Spin tip='Loading...' spinning={isLoading} size='large'>
        <Header />
        <div className={s.content}>
          <Navigation />

          <MainRoutes />
        </div>
      </Spin>
    </div>
  );
};
